import styled from 'styled-components';
import { Typography } from '@mui/material';

export const Wrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  column-gap: 16px;
`;

export const Text = styled(Typography)`
  font-size: 16px;
  margin-bottom: 24px;
  min-width: 320px;
`;
